import { CustomCard } from "@/components";
import { IMarketWithChildren } from "@/models";
import { RouteNames } from "@/router";
import { Vue, Component, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
    components: {
        CustomCard,
        draggable,
    },
})
export default class Markets extends Vue {
    public RouteNames = RouteNames;

    public filterText = "";

    public currentPage = 1;

    public itemsPerPage = 100;

    public filteredMarkets: IMarketWithChildren[] = [];

    public slicedMarkets: IMarketWithChildren[] = [];

    public get markets(): IMarketWithChildren[] {
        return this.$store.getters["app/markets"];
    }

    @Watch("filterText")
    watchFitlerText(value): void {
        this.currentPage = 1;
        this.computeFilteredMarkets(value);
    }

    computeFilteredMarkets(filterText = this.filterText) {
        if (filterText != null && filterText.length > 0) {
            this.filteredMarkets = this.markets.filter(curr => {
                return curr.name.startsWith(filterText) || curr.children.some(child => child.name.startsWith(filterText));
            });
            return;
        }
        this.filteredMarkets = this.markets;
    }

    @Watch("filteredMarkets")
    handleFilteredMarkets() {
        this.doPrepareSlicedMarkets();
    }
    @Watch("currentPage")
    handleCurrentPage() {
        this.doPrepareSlicedMarkets();
    }
    @Watch("itemsPerPage")
    handleItemsPerPage() {
        this.doPrepareSlicedMarkets();
    }

    doPrepareSlicedMarkets() {
        this.slicedMarkets = this.filteredMarkets.slice(
            (this.currentPage - 1) * this.itemsPerPage,
            (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage,
        );
    }

    get numberOfPages(): number {
        const result = this.filteredMarkets.length / this.itemsPerPage;

        if (result > Math.floor(result)) return Math.floor(result) + 1;

        return result;
    }

    async mounted(): Promise<void> {
        await this.$store.dispatch("app/loadAllMarket");
        this.computeFilteredMarkets();
        this.doPrepareSlicedMarkets();
    }
}
